import { Stack } from '@mui/material'
import { pick } from 'ramda'
import { useParams } from 'react-router-dom'

import { HistoricList, PublishDialog } from '@/components'
import { useComponentProvider } from '@/components/ViewComponentModal/ViewComponentProvider'
import { useListHistory } from '@/hooks'
import {
  useGetCustomComponent,
  useUpdateCustomComponent,
} from '@/screens/ComponentLibrary/hooks'
import {
  CustomComponentEnhanced,
  storeKey,
} from '@/screens/ComponentLibrary/hooks/CONSTANTS'

import { CustomComponentData } from './CodeEditor'

export default function History() {
  const { orgID } = useParams()
  const { componentID } = useComponentProvider()

  const queryKey = [storeKey, componentID, 'history']

  const updateComponent =
    useUpdateCustomComponent<CustomComponentData>(componentID)
  const currentComponent =
    useGetCustomComponent<CustomComponentData>(componentID)
  const historyQuery = useListHistory(queryKey, 'customComponent', {
    id: componentID,
  })
  const parseData = (
    data?: CustomComponentEnhanced<CustomComponentData> | null
  ) => {
    if (!data) return {}
    console.log('data', data)
    return pick(['description', 'name', 'settings'], data)
  }

  const restoreVersion = async (data: Record<string, unknown>) => {
    await updateComponent.mutateAsync({
      ...parseData(
        data as unknown as CustomComponentEnhanced<CustomComponentData>
      ),
    })
  }

  return (
    <Stack height="70vh">
      <HistoricList data={historyQuery.data} restore={restoreVersion} />
      <PublishDialog
        dataToSave={parseData(currentComponent.data)}
        extraInfo={{
          customComponentHistoryId: componentID,
          organizationHistoryId: orgID,
        }}
        queryKey={queryKey}
      />
    </Stack>
  )
}
